"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningIcon = void 0;
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
/* This icon resembles an alert icon, but it’s slightly larger and is typically used in confirmation pop-ups.
 * It is duplicated in manatee/src/components/icons/alerts as part of the Icon component.
 */
const WarningIcon = ({ fill, size, title = "Warning" }) => (react_1.default.createElement(Base_1.Base, { title: title, size: size ? size : 16, smooth: true },
    react_1.default.createElement("path", { fill: fill ? fill : "#f93", d: "M14.9 12.7L8.7 1.4c-.3-.5-1-.5-1.3 0L1.1 12.7c-.3.6.1 1.3.7 1.3h12.5c.5 0 .9-.7.6-1.3zM9 12H7v-2h2zm0-3H7V4h2z" })));
exports.WarningIcon = WarningIcon;
//# sourceMappingURL=WarningIcon.js.map